var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#15C462"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4359_38433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50059 1.97852C4.51752 1.97852 2.10059 4.45 2.10059 7.50039C2.10059 10.5508 4.51752 13.0223 7.50059 13.0223C10.4837 13.0223 12.9006 10.5508 12.9006 7.50039C12.9006 4.45 10.4837 1.97852 7.50059 1.97852ZM9.24252 5.71914C9.62792 5.71914 9.9393 6.03754 9.9393 6.43164C9.9393 6.82574 9.62792 7.14414 9.24252 7.14414C8.85712 7.14414 8.54575 6.82574 8.54575 6.43164C8.54575 6.03754 8.85712 5.71914 9.24252 5.71914ZM5.75865 5.71914C6.14405 5.71914 6.45542 6.03754 6.45542 6.43164C6.45542 6.82574 6.14405 7.14414 5.75865 7.14414C5.37325 7.14414 5.06188 6.82574 5.06188 6.43164C5.06188 6.03754 5.37325 5.71914 5.75865 5.71914ZM10.0003 9.50875C9.3797 10.2702 8.46954 10.7066 7.50059 10.7066C6.53163 10.7066 5.62147 10.2702 5.00091 9.50875C4.70478 9.14582 5.24042 8.6916 5.53655 9.05231C6.0243 9.65125 6.73849 9.99191 7.50059 9.99191C8.26268 9.99191 8.97688 9.64902 9.46462 9.05231C9.75639 8.6916 10.2942 9.14582 10.0003 9.50875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4359_38433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9219,
    height: 11.2742,
    fill: "white",
    transform: "translate(2.1001 1.79883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSmile);
export default __webpack_public_path__ + "static/media/GreenSmile.0b53f46358390b9a9779089597344f35.svg";
export { ForwardRef as ReactComponent };